var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('pb-icon',{staticClass:"fas fa-exclamation-circle fa-2x"})],1),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v("Não foi possível carregar o módulo.")]),_vm._v(" "),_c('p',[_vm._v("Verifique sua conexão e tente novamente mais tarde!")])])
}]

export { render, staticRenderFns }